module.exports = __webpack_public_path__ + "static/media/setupweathericon.8beff3d5.svg";